const parsePeriodLabel = label => {
  const date = new Date(label);
  return isNaN(date.getTime()) ? null : date;
};

export const sortSummaryPeriodsChronologically = summary => {
  if (!summary?.periodLabels?.length) return summary;

  const order = summary.periodLabels
    .map((label, index) => ({ index, date: parsePeriodLabel(label) }))
    .sort((a, b) => {
      if (!a.date || !b.date) return 0;
      return a.date - b.date;
    })
    .map(entry => entry.index);

  const isAlreadySorted = order.every(
    (originalIndex, i) => originalIndex === i
  );
  if (isAlreadySorted) return summary;

  const reorder = arr => (arr ? order.map(index => arr[index]) : arr);
  const reorderRow = row =>
    row ? { ...row, periods: reorder(row.periods) } : row;

  return {
    ...summary,
    periodLabels: reorder(summary.periodLabels),
    periodIds: reorder(summary.periodIds),
    totalRow: reorderRow(summary.totalRow),
    rows: summary.rows?.map(reorderRow)
  };
};
